export default __webpack_public_path__ + "static/media/pyramids.2eed25aebc4a48baff04da3f7b33140f.jpg";